import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import type { ChildRouteContext } from "@/root";
import { throwIfHasNoPermission } from "@/utils/permissions";

import EntryForm from "@/modules/handbook/admin/components/EntryForm";
import { fetchEntryQueryOptions } from "@/modules/handbook/admin/services";

export const Route = createFileRoute(
  "/admin/_panel/_handbook/handbook/entries/$entry",
)({
  component: Component,
  parseParams: (params) => ({
    entry: z.number().int().parse(Number(params.entry)),
  }),
  beforeLoad: ({ context }) => {
    throwIfHasNoPermission(context.user, "handbook.handbook-entry.update");

    return {
      crumb: [
        {
          label: context.t("Edit", { ns: "core.shared" }),
        },
      ],
    } satisfies ChildRouteContext;
  },
  loader: (opts) =>
    opts.context.queryClient.ensureQueryData(
      fetchEntryQueryOptions(opts.params.entry),
    ),
  stringifyParams: ({ entry }) => ({ entry: `${entry}` }),
});

function Component() {
  const { entry } = Route.useParams();
  return <EntryForm id={entry} />;
}
